import { render, staticRenderFns } from "./add_coupon2.vue?vue&type=template&id=60b1ff20&scoped=true"
import script from "./add_coupon2.vue?vue&type=script&lang=js"
export * from "./add_coupon2.vue?vue&type=script&lang=js"
import style0 from "./add_coupon2.vue?vue&type=style&index=0&id=60b1ff20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1ff20",
  null
  
)

export default component.exports